import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=36da3c6e&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"
import style0 from "./Register.vue?vue&type=style&index=0&id=36da3c6e&prod&lang=css"
import style1 from "./Register.vue?vue&type=style&index=1&id=36da3c6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36da3c6e",
  null
  
)

export default component.exports